export const ENDPOINTS = {
  ORG_ADMIN: {
    SSO: {
      LIST: "/api/v1/org-admin/:organization_id/sso/connections",
      ACCESS_TICKET: "/api/v1/org-admin/:organization_id/sso/access-ticket",
      DELETE:
        "/api/v1/org-admin/:organization_id/sso/connections/:connection_id",
    },
  },
  ORG: {
    ONBOARDING: {
      SHOW: "/api/v1/org/:organization_id/onboarding",
      UPDATE: "/api/v1/org/:organization_id/onboarding",
    },
    NANGO: {
      CONNECT_SESSION: "/api/v1/org/:organization_id/nango-connect-session",
    },
    PIPEDREAM: {
      CONNECT_ORG_TOKEN: "/api/v2/org/:organization_id/pipedream-connect-token",
      CONNECT_USER_TOKEN:
        "/api/v2/org/:organization_id/user/:user_id/pipedream-connect-token",
    },
  },
};
